import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Shown when a route matches nothing.
 *
 * React Router renders exactly nothing for an unmatched path, and this app had no catch-all,
 * so any bad link — a stale deep link from Remi, an old bookmark, a renamed screen, a typo —
 * produced a blank page. Blank is the worst possible failure here: there is no error, no
 * explanation and no way back, so it reads as the portal being broken rather than the link
 * being wrong.
 *
 * The attempted path is shown deliberately. It is what turns "the portal is broken" into a
 * reportable detail, and it is the fastest way to spot a route that has drifted out of step
 * with the one thing pointing at it.
 */
export default function ScreenNotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  const attempted = `${location.pathname}${location.search || ""}`;

  return (
    <div className="hv-panel" style={{ margin: "24px", maxWidth: "620px" }}>
      <div className="hv-panel__head">
        <span className="hv-panel__heading">That screen isn&apos;t available</span>
      </div>

      <div className="hv-panel__body">
        <p style={{ marginBottom: "12px" }}>
          Nothing in the billing portal matches this address. The link that brought you here is
          probably pointing at a screen that has been renamed or moved.
        </p>

        <p style={{ marginBottom: "16px" }}>
          <span style={{ opacity: 0.7 }}>Address tried: </span>
          <code
            style={{
              background: "rgba(20, 48, 58, 0.07)",
              padding: "2px 6px",
              borderRadius: "4px",
              wordBreak: "break-all",
            }}
          >
            {attempted}
          </code>
        </p>

        <div className="hv-row hv-row--tight" style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          <button
            type="button"
            className="hv-btn hv-btn--primary"
            onClick={() => navigate("/Billingdasboard", { replace: true })}
          >
            Go to dashboard
          </button>
          <button type="button" className="hv-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
